// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"712":"2f51a5e2","750":"268bac92"}[chunkId] + ".chunk.js";
};